import { render, staticRenderFns } from "./TagProductsTable.vue?vue&type=template&id=637c4c44"
import script from "./TagProductsTable.vue?vue&type=script&lang=js"
export * from "./TagProductsTable.vue?vue&type=script&lang=js"
import style0 from "./TagProductsTable.vue?vue&type=style&index=0&id=637c4c44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports